import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-server-busy',
  templateUrl: './server-busy.component.html',
  styleUrls: ['./server-busy.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ServerBusyComponent implements OnInit {
  @Input() customClass: string = '';
  constructor() { }

  ngOnInit() { }

}
